exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable > tbody.loading[data-v-0775a331] {\n  opacity: 0.5;\n}\n.loading[data-v-0775a331] {\n  opacity: 0.5;\n}\n", ""]);

// exports
